import {
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps,
  LightMode,
} from '@chakra-ui/react'
import { SwashbuckleComponentProps } from '../../types'

type ButtonProps = SwashbuckleComponentProps & ChakraButtonProps

export const Button = ({
  'data-qa': dataQa,
  className,
  ...chakraProps
}: ButtonProps) => {
  return (
    // Force buttons to always be in light mode. The way that we do theming is a little
    // different than Chakra intends. They use one color ramp for both themes and
    // adjust which color value they point to depending on the color mode. We, on
    // the other hand, swap out the actual color definitions based on the color mode.
    // Rather than Chakra being opinionated and selecting the color to use for us,
    // we force light mode to ensure that the appropriate colors are used
    <LightMode>
      <ChakraButton data-qa={dataQa} className={className} {...chakraProps} />
    </LightMode>
  )
}

Button.displayName = 'Button'
